import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import _ from "lodash";
import { fetchCardioResultsV2, getHR } from "../api";
import Header from "../components/Header";
import Waiting from "../components/Waiting";
import cardioMessageList from "../enum/cardioMessageList";
import { initWebcamV2, startWebcamV2, stopWebcamV2 } from "../utils/cardio/webcam-operations";
import calculateBrightness from "../utils/cardio/calculateBrightness";
import drawDynamicProgressBar from "../utils/cardio/drawDynamicProgressBar";
import getSelectedShapeRGBs from "../utils/cardio/getSelectedShapeRGBs";
import pico from "../utils/pupil-detection/pico";
import { trackCardioTestPage } from "../utils/mixpanel";
import { playAudio, playAudioInit } from "../utils/covid/TestPageUtil";
import GreenLight from "../assets/SVG/icons/GreenLight.svg";
import RedLight from "../assets/SVG/icons/RedLight.svg";
import GreenDistance from "../assets/SVG/icons/GreenDistance.svg";
import RedDistance from "../assets/SVG/icons/RedDistance.svg";
import GreenMotion from "../assets/SVG/icons/MotionGreenIcon.svg";
import RedMotion from "../assets/SVG/icons/MotionRedIcon.svg";
import HRW from "../assets/SVG/icons/HRWhite.svg";
import HRG from "../assets/SVG/icons/HRGreen.svg";
import CloseIcon from "../assets/SVG/buttons/close-icon.svg";
import NoLight from "../assets/SVG/icons/No-light.svg";
import GoodLight from "../assets/SVG/icons/Good-light.svg";
import Light from "../assets/SVG/icons/light.png";
import NoGlasses from "../assets/SVG/icons/no-glass.png";
import CameraDistance from "../assets/SVG/icons/keep-distance-icon.png";
import MotionIcon from "../assets/SVG/icons/motion-icon.png";
import CountAudio_1 from "../assets/audio/1.mp3";
import CountAudio_2 from "../assets/audio/2.mp3";
import CountAudio_3 from "../assets/audio/3.mp3";
import AudioComeCloser from "../assets/audio/close-to-camera.mp3";
import AudioCheckLight from "../assets/audio/check-lights.mp3";
import config from "../config";
import "../styles/cardioonly.css";

let cancelLoop = false;
let start;

let glight = new Image();
let rlight = new Image();
let gdistance = new Image();
let rdistance = new Image();
let gmotion = new Image();
let rmotion = new Image();
let noLightIcon = new Image();
let goodLightIcon = new Image();
let HRWhite = new Image();
let HRGreen = new Image();

glight.src = GreenLight;
rlight.src = RedLight;
gdistance.src = GreenDistance;
rdistance.src = RedDistance;
gmotion.src = GreenMotion;
rmotion.src = RedMotion;
noLightIcon.src = NoLight;
goodLightIcon.src = GoodLight;
HRWhite.src = HRW;
HRGreen.src = HRG;

export class CardioOnly extends Component {
  constructor(props) {
    super(props);
    this.state = {
      proceed: false,
      isCounting: true,
      counter: "",
      isComeCloserPlaying: false,
      lowBrightness: false,
      lightingScore: 0,
      previousLightingScore: 0,
      baseWidth: window.screen.width > window.screen.height ? 640 : 480,
      maxResolutionWidth: window.screen.width > window.screen.height ? 640 : 480,
      maxResolutionHeight: window.screen.width > window.screen.height ? 480 : 640,
      isLoading: false,
      isCamLoading: true,
      progressValue: 0,
      isCardioDone: false,
      minimumFrames: 1200,
      rgbs: {
        r: [],
        g: [],
        b: [],
      },
      nose_rgbs: {
        r: [],
        g: [],
        b: [],
      },
      forehead_rgbs: {
        r: [],
        g: [],
        b: [],
      },
      cheek1_rgbs: {
        r: [],
        g: [],
        b: [],
      },
      cheek2_rgbs: {
        r: [],
        g: [],
        b: [],
      },
      coordinates: {
        x: [],
        y: [],
        r: [],
      },
      timeStamp: [],
      liveHR: null,
      loopStartTime: [],
      loopEndTime: [],
      waitTime: null,
      accumulativeMotion: 0,
      intervalAccumulativeMotion: 0,
      intervalMotionTime: null,
      lastFrameX: null,
      lastFrameY: null,
      lastFrameR: null,
      showMotionError: false,
      bp: null,
      spo2: null,
      hr: null,
      hrv: null,
      rr: null,
      hi: null,
      af: null,
      error: null,
      landscapeMode: window.screen.width > window.screen.height ? true : false,
      isFailed: false,
      errorMsg: null,
      loadingMsg: "Preparing the environment. please wait...",
      isPendingHR: false
    };

    this.webcamElement = React.createRef();
    this.canvasElement = React.createRef();
    this.canvasMaskElement = React.createRef();
    this.canvasProgressElement = React.createRef();

    if (cancelLoop) {
      cancelLoop = false;
    }
  }

  componentDidMount = async () => {
    document.title = "Cardio measurements";
    if (this.props?.user?.uid) {
      trackCardioTestPage(this.props.user.uid);
    }
    this.checkSubscriptionStatus();
  };

  componentWillUnmount() {
    stopWebcamV2(this.webcamElement.current);
  }

  fullRedirectToHome() {
    window.location.replace("/home");
  }
  getTrialAccessByUsage() {
    const totalCardioTestCount = this.props.user?.userStatus?.totalCardioTestCount;
    const cardioTrialTestLimit =
      this.props.user?.affiliateAccount?.cardioTrialTestLimit === undefined
        ? this.props.user?.cardioTrialTestLimit
        : this.props.user?.affiliateAccount?.cardioTrialTestLimit;
    return { cardio: totalCardioTestCount < cardioTrialTestLimit };
  };

  async checkSubscriptionStatus() {
    const user = this.props.user;
    const subscriptions = this.props.subscriptions?.data || [];
    // If user account is free let it pass
    if (user?.accountType === "free") return;

    // If user trial is expired
    if (user?.accountType === "trial_expired") {
      return this.fullRedirectToHome();
    }

    // Check if user has accessed trial usage
    if (user?.accountType === "trial") {
      if (!this.props.user.cardio_access) {
        return this.fullRedirectToHome();
      }
      const trialAccessByUsage = this.getTrialAccessByUsage();
      if (!trialAccessByUsage.cardio) {
        return this.fullRedirectToHome();
      }
    }

    // Check if account is active and they have access

    if (user?.accountType === "active") {
      const cardioSubs = subscriptions.filter((sub) => sub.productType === "cardio");
      const activeCardioSubs = cardioSubs.filter((sub) => sub.status === "active" || sub.status === "pending_cancel");
      if (_.isEmpty(activeCardioSubs)) {
        return this.fullRedirectToHome();
      }
    }
  }

  startCardio = async () => {
    window.audioInstance = await playAudioInit()
    this.setState({ proceed: true }, async () => {
      await this.init();

      try {
        this.webcamElement.current.onloadeddata = async () => {
          this.initPico();
        };
      } catch (error) {
        console.log(error);
      }
    });
  };

  setResolution = (stream_settings) => {
    const { width, height } = stream_settings;
    const aspectRatio = width > height ? width / height : height / width;
    this.setState({
      maxResolutionWidth: this.state.baseWidth,
      maxResolutionHeight: isMobile ? this.state.baseWidth * aspectRatio : this.state.baseWidth / aspectRatio,
    });
  };

  init = async () => {
    let result = await initWebcamV2(this.webcamElement.current, "user", this.canvasElement.current);
    if (result) {
      this.setState({
        isCamLoading: false,
        isFailed: true,
        errorMsg: result,
      });
      stopWebcamV2(this.webcamElement.current);
    } else {
      await startWebcamV2(this.webcamElement.current, this.setResolution);
    }
  };

  handleRetry = () => {
    window.location.reload();
  };

  handleClose = () => {
    cancelLoop = true; //stopping the loop
    window.audioInstance = null;
    stopWebcamV2(this.webcamElement.current);
    this.props.history.push("/home");
  };

  initFacefinder = async () => {
    return new Promise((resolve) => {
      let cascadeurl = "https://iselfieprod.blob.core.windows.net/iselfie-prod-public/models/facefinder";
      fetch(cascadeurl).then((response) => {
        response.arrayBuffer().then((buffer) => {
          let bytes = new Int8Array(buffer);
          resolve(pico.unpack_cascade(bytes));
        });
      });
    });
  };

  count = async () => {
    this.setState({ isCounting: true });
    for (let i = 3; i > 0; i--) {
      if (i === 3) {
        this.setState({ counter: 3 });
        await playAudio(CountAudio_3);
      } else if (i === 2) {
        this.setState({ counter: 2 });
        await playAudio(CountAudio_2);
      } else {
        this.setState({ counter: 1 });
        await playAudio(CountAudio_1);
      }
      await this.wait(250);
    }
    this.setState({ counter: "", isCounting: false });
  };

  initPico = async () => {
    if (cancelLoop) return;
    let update_memory = pico.instantiate_detection_memory(5);
    let facefinder_classify_region = (r, c, s, pixels, ldim) => {
      return -1.0;
    };

    facefinder_classify_region = await this.initFacefinder();

    let rgba_to_grayscale = (rgba, nrows, ncols) => {
      let gray = new Uint8Array(nrows * ncols);
      for (let r = 0; r < nrows; ++r) {
        for (let c = 0; c < ncols; ++c) {
          gray[r * ncols + c] =
            (2 * rgba[r * 4 * ncols + 4 * c + 0] +
              7 * rgba[r * 4 * ncols + 4 * c + 1] +
              1 * rgba[r * 4 * ncols + 4 * c + 2]) /
            10;
        }
      }
      return gray;
    };

    this.webcamElement.current.width = this.state.maxResolutionWidth;
    this.webcamElement.current.height = this.state.maxResolutionHeight;

    this.setState({ isCamLoading: false });

    this.count();

    let draw = async (video, dt) => {
      if (this.state.maxResolutionWidth <= 0) {
        /* This condition will prevent the error of indexSize in drawtmage function */
        return;
      }

      this.canvasElement.current.width = this.canvasProgressElement.current.width = this.canvasMaskElement.current.width = this.state.maxResolutionWidth;
      this.canvasElement.current.height = this.canvasProgressElement.current.height = this.canvasMaskElement.current.height = this.state.maxResolutionHeight;

      let mctx = this.canvasMaskElement.current.getContext("2d");
      let ctx = this.canvasElement.current.getContext("2d");
      let pctx = this.canvasProgressElement.current.getContext("2d");

      //main blurred canvas
      ctx.drawImage(video, 0, 0, this.state.maxResolutionWidth, this.state.maxResolutionHeight);

      //centered small circle canvas
      mctx.drawImage(video, 0, 0, this.state.maxResolutionWidth, this.state.maxResolutionHeight);

      if (this.state.isCounting) {
        //showing count above the circle
        pctx.font = "20px century-gothic";
        pctx.fillStyle = "#fff";
        pctx.textAlign = "center";
        pctx.fillText(
          this.state.counter,
          this.canvasProgressElement.current.width / 2,
          this.canvasProgressElement.current.height * 0.06
        );

        return;
      }

      //Calculating the Brightness
      const brightnessResult = calculateBrightness(
        this.state.maxResolutionWidth,
        this.state.maxResolutionHeight,
        this.canvasElement.current
      );

      const aspectRatio = this.state.maxResolutionWidth / this.state.maxResolutionHeight;
      let diff = 0;
      let radius = 0.28;
      if (!isMobile && aspectRatio > 1.5) {
        radius = 0.34;
        diff = 15;
      }
      this.state.landscapeMode
        ? drawDynamicProgressBar(
            pctx,
            this.canvasProgressElement.current.width / 2,
            this.canvasProgressElement.current.height * 0.45,
            10,
            this.canvasProgressElement.current.height * radius,
            this.state.progressValue
          )
        : drawDynamicProgressBar(
            pctx,
            this.canvasProgressElement.current.width / 2,
            this.canvasProgressElement.current.height / 2,
            15,
            this.canvasProgressElement.current.height * 0.325,
            this.state.progressValue
          );

      //error icons and text on canvas
      pctx.drawImage(
        this.state.showMotionError ? rmotion : gmotion,
        this.canvasProgressElement.current.width / 2 - 133.5,
        this.canvasProgressElement.current.height - 80 + diff,
        55,
        55
      );
      pctx.drawImage(
        this.state.lowBrightness ? rlight : glight,
        this.canvasProgressElement.current.width / 2 - 67.5,
        this.canvasProgressElement.current.height - 80 + diff,
        61,
        61
      );
      pctx.drawImage(
        this.state.isComeCloserPlaying ? rdistance : gdistance,
        this.canvasProgressElement.current.width / 2 + 1,
        this.canvasProgressElement.current.height - 80 + diff,
        61,
        61
      );
      pctx.drawImage(
        this.state.liveHR > 0 ? HRGreen : HRWhite,
        this.canvasProgressElement.current.width / 2 + 70,
        this.canvasProgressElement.current.height - 80 + diff,
        55,
        55
      );

      pctx.font = "18px century-gothic";
      pctx.textAlign = "center";
      pctx.fillStyle = "#fff";
      pctx.fillText(
        this.state.liveHR > 0 ? this.state.liveHR : "--",
        this.canvasProgressElement.current.width / 2 + 98,
        this.canvasProgressElement.current.height - 40 + diff
      );

      //showing percentage above the circle
      pctx.font = "20px century-gothic";
      pctx.fillStyle = "#fff";
      pctx.textAlign = "center";
      pctx.fillText(
        this.state.progressValue + " %",
        this.canvasProgressElement.current.width / 2,
        this.canvasProgressElement.current.height * 0.06
      );

      let rgba = mctx.getImageData(0, 0, this.state.maxResolutionWidth, this.state.maxResolutionHeight).data;

      let image = {
        pixels: rgba_to_grayscale(rgba, this.state.maxResolutionHeight, this.state.maxResolutionWidth),
        nrows: this.state.maxResolutionHeight,
        ncols: this.state.maxResolutionWidth,
        ldim: this.state.maxResolutionWidth,
      };

      let params = {
        shiftfactor: 0.1, // move the detection window by 10% of its size
        minsize: 100, // minimum size of a face
        maxsize: 5000, // maximum size of a face
        scalefactor: 1.05, // for multiscale processing: resize the detection window by 10% when moving to the higher scale
      };

      let dets = pico.run_cascade(image, facefinder_classify_region, params);
      dets = update_memory(dets);
      dets = pico.cluster_detections(dets, 0.01);

      // draw predictions
      for (let i = 0; i < dets.length; i++) {
        if (dets[i][3] > 50.0) {
          let r, c, s;

          // Nose
          let noseX = dets[i][1] - dets[i][2] / 8;
          let noseY = dets[i][0];
          let noseW = (dets[i][2] / 8) * 2;
          let noseH = noseW;

          // Forehead
          let foreheadX = dets[i][1] - dets[i][2] / 6;
          let foreheadY = dets[i][0] - dets[i][2] / 2;
          let foreheadW = (dets[i][2] / 6) * 2;
          let foreheadH = foreheadW;

          //Cheek1
          let cheek1X = dets[i][1] - dets[i][2] / 4 - (dets[i][2] / 8) * 0.8;
          let cheek1Y = dets[i][0] + dets[i][2] / 8 - (dets[i][2] / 8) * 0.8;
          let cheek1W = (dets[i][2] / 8) * 0.8 * 2;
          let cheek1H = cheek1W;

          //Cheek2
          let cheek2X = dets[i][1] + dets[i][2] / 4 - (dets[i][2] / 8) * 0.8;
          let cheek2Y = dets[i][0] + dets[i][2] / 8 - (dets[i][2] / 8) * 0.8;
          let cheek2W = (dets[i][2] / 8) * 0.8 * 2;
          let cheek2H = cheek2W;

          //Face
          let c1Canvas = document.createElement("canvas");
          c1Canvas.width = this.state.maxResolutionWidth;
          c1Canvas.height = this.state.maxResolutionHeight;
          let c1Ctx = c1Canvas.getContext("2d");
          c1Ctx.drawImage(video, 0, 0, this.state.maxResolutionWidth, this.state.maxResolutionHeight);

          let nimg = c1Ctx.getImageData(noseX, noseY, noseW, noseH);
          let fimg = c1Ctx.getImageData(foreheadX, foreheadY, foreheadW, foreheadH);
          let c1img = c1Ctx.getImageData(cheek1X, cheek1Y, cheek1W, cheek1H);
          let c2img = c1Ctx.getImageData(cheek2X, cheek2Y, cheek2W, cheek2H);

          let ims = [nimg.data, fimg.data, c1img.data, c2img.data];

          //motion detection
          if (this.state.lastFrameX != null && this.state.lastFrameY != null) {
            let motion_magnitude = Math.sqrt(
              Math.pow(this.state.lastFrameX - dets[i][1], 2) + Math.pow(this.state.lastFrameY - dets[i][0], 2)
            );
            let tmpAccMotion = this.state.accumulativeMotion + motion_magnitude;
            let tmpInterAccMotion = this.state.intervalAccumulativeMotion + motion_magnitude;

            this.setState({
              accumulativeMotion: tmpAccMotion,
              intervalAccumulativeMotion: tmpInterAccMotion,
              lastFrameX: dets[i][1],
              lastFrameY: dets[i][0],
              lastFrameR: dets[i][3],
            });

            let motionTimeCount = Math.abs(this.state.intervalMotionTime - performance.now());
            if (motionTimeCount >= 1000) {
              const motion = (200 / 480) * Math.min(this.state.maxResolutionWidth, this.state.maxResolutionHeight);
              this.setState({
                showMotionError: this.state.intervalAccumulativeMotion > motion ? true : false,
                intervalAccumulativeMotion: 0,
                intervalMotionTime: performance.now(),
              });
            }
          } else {
            this.setState({
              intervalMotionTime: performance.now(),
              lastFrameX: dets[i][1],
              lastFrameY: dets[i][0],
              lastFrameR: dets[i][3],
            });
          }
          const distance = isMobile ? 0.22 : 0.12;
          if (dets[i][2] / 2 / this.state.maxResolutionWidth < distance && !this.state.isCardioDone) {
            //distance check
            await this.playComeCloser();
          } else if (
            // this.state.lightingScore <= 30
            brightnessResult < config.test.brightness_threshold &&
            !this.state.isCardioDone
          ) {
            //brightness check
            await this.playCheckLights();
          } else if (!this.state.isCardioDone) {
            // This section is for collecting RGB values from ROIs before starting the Cardio test
            if (this.state.rgbs["r"].length >= this.state.minimumFrames) {
              this.setState({
                isCardioDone: true,
                isLoading: true,
              });
              cancelLoop = true; //stopping the loop
              //fetching the results
              this.fetchResults();
            } else {
              const rgbsResult = getSelectedShapeRGBs(
                ims,
                this.state.rgbs,
                this.state.nose_rgbs,
                this.state.forehead_rgbs,
                this.state.cheek1_rgbs,
                this.state.cheek2_rgbs,
                this.state.timeStamp
              );
              const coordinates = {
                x: [...this.state.coordinates.x, dets[i][1]],
                y: [...this.state.coordinates.y, dets[i][0]],
                r: [...this.state.coordinates.r, dets[i][3]],
              };
              this.setState((prevState) => {
                let newState = {
                  ...prevState,
                  rgbs: rgbsResult.rgbs,
                  nose_rgbs: rgbsResult.nose_rgbs,
                  forehead_rgbs: rgbsResult.forehead_rgbs,
                  cheek1_rgbs: rgbsResult.cheek1_rgbs,
                  cheek2_rgbs: rgbsResult.cheek2_rgbs,
                  coordinates: coordinates,
                  timeStamp: rgbsResult.timestamp,
                };
                return newState;
              });
              let value = Math.ceil((this.state.rgbs["r"].length / this.state.minimumFrames) * 100);
              this.setState({ progressValue: value });
            }

            if (
              !this.state.isPendingHR &&
              this.state.rgbs["r"].length >= 500 &&
              this.state.rgbs["r"].length % 100 == 0 &&
              this.state.rgbs["r"].length <= 1100
            ) {
              this.getLiveHRResults();
            }
          }
        }
      }
    };

    this.drawing(draw);
  };

  drawing = (callback) => {
    let loop = async () => {
      start = performance.now();
      callback(this.webcamElement.current);

      let end = performance.now();
      let time = end - start;

      if (time < 40) {
        await this.wait((40 - time) * 0.9);
      }

      if (!cancelLoop) {
        requestAnimationFrame(loop);
      }
    };
    loop();
  };

  playComeCloser = async () => {
    if (!this.state.isComeCloserPlaying && !this.state.lowBrightness) {
      // This condition is to avoid playing back come closer and move to brighter area at the same time
      this.setState({ isComeCloserPlaying: true });
      await playAudio(AudioComeCloser);
      await this.wait(250);
      this.setState({ isComeCloserPlaying: false });
    }
  };

  playCheckLights = async () => {
    if (!this.state.lowBrightness && !this.state.isComeCloserPlaying) {
      // This condition is to avoid playing back come closer and move to brighter area at the same time
      this.setState({ lowBrightness: true });
      await playAudio(AudioCheckLight);
      await this.wait(250);
      this.setState({ lowBrightness: false });
    }
  };

  wait = async (ms) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(ms);
      }, ms);
    });
  };

  getLiveHRResults = async() => {
    this.setState({ isPendingHR: true })
    const payload = {
        rgbs: this.state.rgbs,
        timestamp: this.state.timeStamp
    };

    const hrResult = await getHR(payload);

    this.setState({liveHR: hrResult.hr, isPendingHR: false});
  };

  fetchResults = async () => {
    const payload = {
      rgbs: {
        ...this.state.rgbs,
        nose_rgbs: this.state.nose_rgbs,
        forehead_rgbs: this.state.forehead_rgbs,
        cheek1_rgbs: this.state.cheek1_rgbs,
        cheek2_rgbs: this.state.cheek2_rgbs,
      },
      coordinates: this.state.coordinates,
      timestamp: this.state.timeStamp,
    };
    const { bp, hr, hrv, rr, spo2, hi, af, error } = await fetchCardioResultsV2(payload);
    this.setState({
      bp,
      hr,
      hrv,
      rr,
      spo2,
      hi,
      af,
      error,
    });

    // Stop the streaming before going to result page.
    stopWebcamV2(this.webcamElement.current);

    //redirecting to results page
    this.props.history.push({
      pathname: "/cardio-result",
      state: {
        cardio: {
          bp: this.state.bp,
          spo2: this.state.spo2,
          hr: this.state.hr,
          hrv: this.state.hrv,
          rr: this.state.rr,
          hi: this.state.hi,
          af: this.state.af,
        },
        motion: this.state.accumulativeMotion,
        width: this.state.maxResolutionWidth,
        height: this.state.maxResolutionHeight,
        timestamp: this.state.timeStamp,
      },
    });
  };

  render() {
    return (
      <>
        {this.state.proceed ? (
          <div className={this.state.landscapeMode ? "container-landscape" : ""}>
            {this.state.isLoading && <Waiting isWaiting={this.state.isLoading} list={cardioMessageList} />}
            <div className="cardiopage">
              <div id="canvas-container">
                <video id="video" ref={this.webcamElement} autoPlay playsInline hidden></video>
                <canvas id="canvas" ref={this.canvasElement} className="mirror"></canvas>
                <canvas id="canvas-progress" ref={this.canvasProgressElement}></canvas>
                <canvas id="canvas-mask" ref={this.canvasMaskElement} className="mirror"></canvas>
                {this.state.isCamLoading && (
                  <Waiting isWaiting={this.state.isCamLoading} message="Preparing the environment..." isMulti={false} />
                )}
                {this.state.isFailed ? (
                  <div className="failed-icon">
                    <div className="loading-text">
                      <p>iSelfie Test requires access to your camera to perform the test.</p>
                      <p>{this.state.errorMsg}</p>
                    </div>
                    <Button variant="primary" id="retry" style={{ padding: 0 }} onClick={this.handleRetry}>
                      Retry
                    </Button>
                  </div>
                ) : (
                  <></>
                )}
                <img
                  src={CloseIcon}
                  className="close-button"
                  data-testid="close-button"
                  alt="Close"
                  onClick={() => {
                    this.handleClose();
                  }}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="container">
            <div className="main beforetest">
              <Header />
              <div className="heading mt-3">
                <p>Before you start:</p>
              </div>
              <div className="wrapper">
                <div className="info">
                  <img src={Light} alt="light" /> <p>Place your face in front of a direct white light.</p>
                </div>
                <div className="info">
                  <img src={NoGlasses} alt="light" />{" "}
                  <p>Take off your glasses or contact lenses and clean off the camera lens.</p>
                </div>
                <div className="info">
                  <img src={CameraDistance} alt="light" />{" "}
                  <p>Keep the camera at the eye level, no more than 12 inches (30cms) from your face.</p>
                </div>
                <div className="info">
                  <img src={MotionIcon} alt="motion" /> <p>Please do not move.</p>
                </div>
              </div>
              <div>
                <button className="understand" data-testid="understand" onClick={this.startCardio}>
                  I understand
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user, subscriptions: state.subscriptions });
export default connect(mapStateToProps, null)(CardioOnly);
